var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn-collect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}},[_c('i',{staticClass:"fa fa-star-o"}),_vm._v("\n\t收藏 "+_vm._s(_vm.count)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8d1f8b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collect.vue
// module id = null
// module chunks = 